export const breakpointValues = {
  small: 640,
  specialSmallMed: 815, // DO NOT USE for anything else. Only created because of how design needs to be for housing animations.
  medium: 960,
  large: 1200,
  xLarge: 1920,
};

/** Do not use **specialSmallMed** outside of existing implementations */
export const breakpoints = {
  small: `${breakpointValues.small}px`,
  smallMed_HOUSING_ANIMATION_ONLY: `${breakpointValues.specialSmallMed}px`,
  medium: `${breakpointValues.medium}px`,
  large: `${breakpointValues.large}px`,
  xLarge: `${breakpointValues.xLarge}px`,
};

export type TBreakpoints = typeof breakpoints;
export type TBreakpointKeys = keyof TBreakpoints;
